import { ListViewLocalChildProps } from '@app/core/list-view/ListViewLocal';
import { MinimumStationsGroup } from '@app/core/types/stations';
import { MrtTable } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { stationGroupsMessages } from '../station-groups-messages';

export type AdminStationGroupsListProps = ListViewLocalChildProps<MinimumStationsGroup>;

/**
 * Read-only table of owned station groups for ListViewLocal. Filters live in the DataToolbar.
 */
export function AdminStationGroupsList({
  data,
  isLoading = false,
  isFetching = false,
  showProgress = true,
}: AdminStationGroupsListProps) {
  const { $t } = useIntl();

  return (
    <Box>
      <MrtTable<MinimumStationsGroup>
        data={data}
        navigateToOnClick={(id) => `/admin/station-groups/${id}`}
        enableNavigateAction
        enableColumnFilters={false}
        enableGlobalFilter={false}
        enableToolbarInternalActions={false}
        state={{
          isLoading,
          showProgressBars: showProgress && (isLoading || isFetching),
        }}
        muiTopToolbarProps={{
          sx: {
            height: '4px !important',
            minHeight: '4px !important',
          },
        }}
        columns={[
          {
            header: $t({
              id: 'common.text.name',
              defaultMessage: 'Nombre',
            }),
            size: 100,
            accessorKey: 'name',
          },
          {
            header: $t(stationGroupsMessages.stationsCountHeader),
            size: 50,
            id: 'stationsCount',
            accessorFn: (row) => row.stations?.length ?? 0,
            Cell: ({ row: { original } }) => original.stations?.length ?? 0,
          },
        ]}
      />
    </Box>
  );
}
